import { getPersistedRegion, setPersistedRegion } from '@/services/region.service'
import { setAPIUrl } from '@/services/api.service'

const state = {
  selectedRegion: getPersistedRegion()
}

const getters = {
  selectedRegion: (s) => s.selectedRegion
}

const mutations = {
  setRegion(s, region) {
    s.selectedRegion = region || null
  }
}

const actions = {
  async selectRegion({ commit }, region) {
    setPersistedRegion(region)
    commit('setRegion', region)
    // Refresh cached API URL so subsequent calls use the region
    await setAPIUrl()
  },
  clearRegion({ commit }) {
    setPersistedRegion(null)
    commit('setRegion', null)
  }
}

export default { namespaced: true, state, getters, mutations, actions }
